import React from 'react';
import './DescriptionList.css';

export interface DescriptionListItem {
  /** Label text for the item */
  label: string;
  /** Value to display - can be text or any React node */
  value: React.ReactNode;
}

export type DescriptionListLayout = 'stacked' | 'horizontal' | 'inline';
export type DescriptionListSize = 'sm' | 'md' | 'lg';

export interface DescriptionListProps {
  /** Array of label/value pairs to display */
  items: DescriptionListItem[];
  /** Layout variant */
  layout?: DescriptionListLayout;
  /** Size variant */
  size?: DescriptionListSize;
  /** Whether to show alternating row backgrounds */
  striped?: boolean;
  /** Additional CSS class */
  className?: string;
}

export const DescriptionList: React.FC<DescriptionListProps> = ({
  items,
  layout = 'stacked',
  size = 'md',
  striped = false,
  className = '',
}) => {
  const classes = [
    'hi-ui-description-list',
    `hi-ui-description-list--${layout}`,
    `hi-ui-description-list--${size}`,
    striped && 'hi-ui-description-list--striped',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <dl className={classes}>
      {items.map((item, index) => (
        <div key={index} className="hi-ui-description-list__item">
          <dt className="hi-ui-description-list__label">{item.label}</dt>
          <dd className="hi-ui-description-list__value">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
};

DescriptionList.displayName = 'DescriptionList';
